import React from "react";
import CustomModal from "components/custom-modal/CustomModal";
import Spinner from "images/image-component/Spinner";
import "./loading-modal.css";

interface Props {
  isOpen: boolean;
  loadingMsg: string;
}

function LoadingModal({ isOpen, loadingMsg }: Props) {
  return (
    <CustomModal isOpen={isOpen}>
      <div className="v1-loading-modal">
        <p className="v1-loading-msg">{loadingMsg}</p>
        <div className="v1-loading-spinner">
          <Spinner size={24} color="var(--brand-hi)" />
        </div>
      </div>
    </CustomModal>
  );
}

export default LoadingModal;
